import { useEffect, useState } from "react";
import {
  getCachedBetbyRendererScriptSrc,
  resolveBetbyRendererScriptSrc,
} from "@/betby/infrastructure/betby/betbyRendererScriptResolver";

export function useBetbyScriptLoaderViewModel() {
  const [src, setSrc] = useState<string | null>(() =>
    getCachedBetbyRendererScriptSrc(),
  );

  useEffect(() => {
    let cancelled = false;

    if (src) {
      return;
    }

    void resolveBetbyRendererScriptSrc().then((resolvedSrc) => {
      if (!cancelled) {
        setSrc(resolvedSrc);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [src]);

  return { src };
}
